export default __webpack_public_path__ + "static/media/partner-winya.0071e109.png";